import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CreateMessageService } from './create-message.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MyDocumentsResolverService implements Resolve<any> {

    constructor(
        private dataService: CreateMessageService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.dataService.getMyDocumentsListObservable();
    }
}
